import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import allRelatorioFilasStore from '../_store'

export const relatoriosFilasMixins = {
  data: () => ({
    queues: [],
    showSkeletonForm: false,
    showSkeleton: false,
  }),

  computed: {
    ...mapGetters('allRelatorioFilasStore', ['getQueues']),

    todasFilasSelecionadas() {
      return this.form.filas.length === this.queues.length
    },
    algumasFilasSelecionadas() {
      return this.form.filas.length > 0 && !this.todasFilasSelecionadas
    },
    icon() {
      if (this.todasFilasSelecionadas) return 'mdi-close-box'
      if (this.algumasFilasSelecionadas) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  async created() {
    registerVuexModule(this.$store, 'allRelatorioFilasStore', allRelatorioFilasStore)
  },

  methods: {
    ...mapActions('allRelatorioFilasStore', ['buscarFilas']),

    toggle() {
      this.$nextTick(() => {
        if (this.todasFilasSelecionadas) {
          this.form.filas.splice(0)
        } else {
          this.form.filas.splice(0)
          this.form.filas = this.queues.map(queue => queue.value)
        }
      })
    },
  },
}
